<template>
  <div style="height: 100%;overflow: auto;">
    <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
          <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
            <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
          </el-select>
      </el-form-item>
    </el-form>
    <div v-if="indibas.length==1" style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;margin-bottom: 45px" :key="i" v-for="(item,i) in indibas">
      <div style="text-align: center;font-size: 14px;line-height: 30px">
        {{item.storename}}
      </div>
      <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
      <!--<van-row style="text-align: left;line-height: 40px;font-size: 12px">
        <van-col span="24">INDIBA购买人数和余次</van-col>
      </van-row>
      <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>-->
      <div>
        <!--<van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="font">购买人数</van-col>
          <van-col span="8" class="font">用完人数</van-col>
          <van-col span="8" class="font">1-3次人数</van-col>
        </van-row>
        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="fontcolor">{{item.buycount}}</van-col>
          <van-col span="8" class="fontcolor">{{item.finishcount }}</van-col>
          <van-col span="8" class="fontcolor">{{item.restcount1}}</van-col>
        </van-row>
        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="font">3-10次人数</van-col>
          <van-col span="8" class="font">10以上人数</van-col>
          <van-col span="8" class="font">总余次</van-col>
        </van-row>
        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="fontcolor">{{item.restcount2}}</van-col>
          <van-col span="8" class="fontcolor">{{item.restcount3}}</van-col>
          <van-col span="8" class="fontcolor">{{item.totalnumber}}</van-col>
        </van-row>-->
        <!--<div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
        <van-row style="text-align: left;line-height: 40px;font-size: 12px">
          <van-col span="24">INDIBA顾客多久未到店</van-col>
        </van-row>
        <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
        -->

        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="font">7天未到店</van-col>
          <van-col span="8" class="font">15天未到店</van-col>
          <van-col span="8" class="font">1月未到店</van-col>
        </van-row>
        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="fontcolor">{{item.day7}}</van-col>
          <van-col span="8" class="fontcolor">{{item.day15}}</van-col>
          <van-col span="8" class="fontcolor">{{item.day30}}</van-col>
        </van-row>
        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="font">2月未到店</van-col>
        </van-row>
        <van-row style="text-align: center;line-height: 40px">
          <van-col span="8" class="fontcolor">{{item.day60}}</van-col>
        </van-row>
      </div>
      <el-divider>7天未到</el-divider>
    <el-table  :data="item.day7indibaBuyInfoVos" style="width: 100%;" ref="table" highlight-current-row>
      <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
      <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
      <el-table-column prop="lastdate"  label="最近到店" align="center"></el-table-column>
    </el-table>
    <el-divider>15天未到</el-divider>
    <el-table  :data="item.day15indibaBuyInfoVos"  style="width: 100%;" highlight-current-row>
      <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
      <el-table-column prop="membername" label="会员姓名" align="center"></el-table-column>
      <el-table-column prop="lastdate"  label="最近到店" align="center"></el-table-column>
    </el-table>
    <el-divider>1月未到</el-divider>
    <el-table  :data="item.day30indibaBuyInfoVos" style="width: 100%;" highlight-current-row>
      <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
      <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
      <el-table-column prop="lastdate"  label="最近到店" align="center"></el-table-column>
    </el-table>
    <el-divider>2月未到</el-divider>
    <el-table  :data="item.day60indibaBuyInfoVos"  style="width: 100%;"  highlight-current-row>
      <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
      <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
      <el-table-column prop="lastdate"  label="最近到店" align="center"></el-table-column>
    </el-table>
    </div>
    <el-table :data="indibas" style="width: 100%;" v-if="indibas.length>1" :height="height" @row-click="openIndibawdddetal">
      <el-table-column fixed prop="storename" width="100" align="center" label="门店名称"></el-table-column>
      <el-table-column  prop="day7" label="7天未到" align="center"></el-table-column>
      <el-table-column  prop="day15" label="15天未到" align="center"></el-table-column>
      <el-table-column  prop="day30" label="1月未到" align="center"></el-table-column>
      <el-table-column  prop="day60" label="2月未到" align="center"></el-table-column>
    </el-table>

  </div>
</template>
<script>
export default {
  data() {
    return {
      cardInfoVos:[],
      show:false,
      indibas:[],
      active: 'home',
      height:window.innerHeight-150,
      storeid:localStorage.getItem("storeid"),
      brands:[],
    };
  },
  created() {

    /*let  userId= this.getUrlKey("userId");
    let code=this.getUrlKey("code");
    if (userId || code) {
      if(userId) {
        this.getCorpUserInfo(userId);
      }
    }
    else{
      window.location.href=this.getBaseUrl()+"/wechatback/getThirdCorpidCode?state=3";
    }*/
    //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjE3Njc3NTYxLCJleHAiOjE2MTc3NjM5NjF9.SQ_6O9vj2_Px4PEzYJ3QKp1MHsDme70PA02SM_l9ACs");
    //this.storeid=localStorage.getItem("storeid");
    this.getStoreInfoByStructsOpen();
    this.getIndibaInfo();
  },
  methods:{
    openIndibawdddetal(row){
      this.$router.push({path:"/indibawdddetal",query:{
          storeid:row.storeid,
      }});
    },
    storeChange(val){
      localStorage.setItem("storeid",val);
      this.storeid=val;
      this.getIndibaInfo();
    },
    getStoreInfoByStructsOpen(){
      let parentstoreid=localStorage.getItem("parentstoreid");
      let staffid=localStorage.getItem("staffid");
      this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
        if(res.sucess){
            this.brands=res.object;
        }
        else{
            this.$message({
              message: res.message,
              type: 'error'
            });
        }
      });
    },
    getCardInfoVoData(item,type){
      if(type==1){
        this.cardInfoVos=item.day7indibaBuyInfoVos;
      }
      else if(type==2){
        this.cardInfoVos=item.day15indibaBuyInfoVos;
      }
      else if(type==3){
        this.cardInfoVos=item.day30indibaBuyInfoVos;
      }
      else if(type==4){
        this.cardInfoVos=item.day60indibaBuyInfoVos;
      }
      this.show=true;
    },
    getCorpUserInfo(staffid){
      let toast=this.$toast.loading({
        mask: true,
        message: '加载中...',
        duration:0
      });
      this.postAxios("/wechat/getCorpUserInfo",{staffid:staffid}).then((res)=>{
        toast.clear();
        if(res.sucess) {
          let data = res.object;
          if (data.staff == null || data.staff == undefined) {
            //如果钉钉没找到就关闭页面
            this.$dialog.alert({
              title: "提示",
              message: "没有找到您的信息"
            }).then(() => {
              window.WeixinJSBridge.call('closeWindow');
            });
            return;
          }
          else {
            this.staff = data.staff;
            localStorage.setItem("token", data.token);
            localStorage.setItem("staffid", data.staff.staffid);
            localStorage.setItem("storeid", data.staff.storeid);
            localStorage.setItem("deptid", data.staff.deptid);
            localStorage.setItem("staffname", data.staff.staffname);
            localStorage.setItem("posid", data.staff.posid);
            this.getIndibaInfo();
          }
        }
        else{
          this.$dialog.alert({
            title:"提示",
            message:res.message
          }).then(()=>{
            window.WeixinJSBridge.call('closeWindow');
          });
        }
      });
    },
    getIndibaInfo(){
      let toast=this.$toast.loading({
        mask: true,
        message: '加载中...',
        duration:0
      });
      this.$post("cardmobilereoprt/getIndibaInfo",{storeid:this.storeid}).then((res)=>{
        toast.clear();
        if(res.sucess){
          this.indibas=res.object;
        }
        else{
          this.$dialog.alert({
            title:"提示",
            message:res.message
          });
        }
      });
    }
  }
};
</script>
<style>
.font{
  font-size: 14px;
}
.fontcolor{
  font-size: 14px;
  color: #1989fa;
}
body,html {margin:0; height:100%;}
</style>


// WEBPACK FOOTER //
// src/page/beauty/indibawdd.vue